<div [innerHTML]="currentText" class="thehtml"></div>
<div class="uk-inline uk-width-expend" *ngIf="showToggleButton && currentText">
  <hr class="hr-dotted">
  <a class="rm_button text-xs uk-link-text uk-position-top-center uk-text-danger" style="margin-top: -9px; background-color: #fff; padding: 0 .5em;" (click)="toggleView()">Read {{isCollapsed? 'Less':'More'}}</a>
</div>
